<section [class.highlight]="viserDetaljer()">
  <button type="button" class="gruppehode" (click)="byttDetaljvisning()">
    <span class="gruppeinformasjon">
      <strong>{{ visningsgruppe().tittel }} {{ 'i' | translate }} {{ visningsgruppe().organisasjonsnavn }}</strong>
      <span>{{ 'Antall møter i år {antall}' | translate:{antall: visningsgruppe().antallMoeterInnevaerendeAar} }}</span>
    </span>
    <span class="gruppe-tellere">
      <span><strong>{{ aggregater()?.antallMoeter || '-' }}</strong>{{ 'møter' | translate }}<small>({{ aggregater()?.antallMoeterAvholdt || '-' }} {{ 'avholdt' | translate }})</small></span>
      <span><strong>{{ aggregater()?.antallSaker || '-' }}</strong>{{ 'saker' | translate }}</span>
      <span><strong>{{ aggregater()?.antallDokumenter || '-' }}</strong>{{ 'dokumenter' | translate }}</span>
      <span><strong>{{ aggregater()?.antallOppgaver || '-' }}</strong>{{ 'oppgaver' | translate }}<small>({{ aggregater()?.antallOppgaverForfalt || '-' }} {{ 'forfalt' | translate }})</small></span>
      <span><strong>{{ aggregater()?.antallBeslutninger || '-' }}</strong>{{ 'beslutninger' | translate }}</span>
      <span><strong>{{ aggregater()?.antallKommentarer || '-' }}</strong>{{ 'kommentarer' | translate }}<small>({{ aggregater()?.antallSvar || '-' }} {{ 'svar' | translate }})</small></span>
      <span><strong>{{ aggregater()?.antallMedlemmer || '-' }}</strong>{{ 'medlemmer' | translate }}<small>{{ aktiveMedlemmer().length }} {{ 'aktive' | translate }}</small><small>{{ visningsgruppe().invitasjoner.length }} {{ 'invitert' | translate }}</small><small>{{ inaktiveMedlemmer().length }} {{ 'deaktivert' | translate }}</small></span>
    </span>
  </button>

  @if (viserDetaljer()) {
    <div class="gruppedetaljer" data-testid="gruppe-detaljer">
      <div class="aksjeeierbok">
        <i class="icon" [class.ion-checkmark-round]="visningsgruppe().aksjeeierbokId !== null"
           [class.tilgangikon-aapen]="visningsgruppe().aksjeeierbokId !== null"
           [class.ion-close-round]="visningsgruppe().aksjeeierbokId === null"
           [class.tilgangikon-stengt]="visningsgruppe().aksjeeierbokId === null" aria-hidden="true"></i>
        {{ 'Aksjeeierbok' | translate }}
        @if (visningsgruppe().aksjeeierbokId === null) {
          <button mat-raised-button color="primary" type="button" class="e2e-opprettaksjeeierbok" (click)="opprettAksjeeierbok()">{{ 'Opprett Aksjeeierbok' | translate }}</button>
        }
      </div>
      <tittel-verdi-samling stil="vertikal">
        <tittel-verdi stil="horisontal" tittel="Gruppe-ID" verdi="{{ visningsgruppe().id }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="nedlastningsTidspunkt" verdi="{{ visningsgruppe().nedlastningsTidspunkt |zoneddatetimeSomPlaindate|plaindate:'medium' }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="AvtaleId" verdi="{{ visningsgruppe().avtaleId }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="moetenummerformat" verdi="{{ visningsgruppe().oppsett.moeteOgSaksNummerFormat.moetenummerformat }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="saksnummerformat" verdi="{{ visningsgruppe().oppsett.moeteOgSaksNummerFormat.saksnummerformat }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="beslutningOrdlydEntall" verdi="{{ visningsgruppe().oppsett.protokollValg.beslutningOrdlydEntall }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="beslutningOrdlydFlertall" verdi="{{ visningsgruppe().oppsett.protokollValg.beslutningOrdlydFlertall }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="inkluderAgendaIInnkalling" verdi="{{ visningsgruppe().oppsett.inkluderAgendaIInnkalling }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="skjulSensitivInformasjonIMeldinger" verdi="{{ visningsgruppe().oppsett.skjulSensitivInformasjonIMeldinger }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="sorterSakerEtterSakstype" verdi="{{ visningsgruppe().oppsett.sorterSakerEtterSakstype }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="spraak" verdi="{{ visningsgruppe().oppsett.spraak }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="tidssone" verdi="{{ visningsgruppe().oppsett.tidssone }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="foreldergruppenavn" verdi="{{ visningsgruppe().foreldergruppenavn }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="gruppemalNavn (kun for maler)" verdi="{{ visningsgruppe().gruppemal?.navn }}"></tittel-verdi>
        <tittel-verdi stil="horisontal" tittel="gruppemalBeskrivelse (kun for maler)" verdi="{{ visningsgruppe().gruppemal?.beskrivelse }}"></tittel-verdi>
      </tittel-verdi-samling>

      <section>
        <h3>{{ 'Autentiseringsmetoder' | translate }}</h3>
        <ul>@for (metode of autentiseringsmetoder(); track metode) { <li>{{ metode | translate }}</li> }</ul>
      </section>

      <section>
        <h3>{{ 'Medlemmer' | translate }} ({{ aktiveMedlemmer().length }})</h3>
        @for (medlem of aktiveMedlemmer(); track medlem.id) {
          <administrasjon-medlem [medlem]="medlem"/>
        }
      </section>

      <section>
        <h3>{{ 'Invitasjoner' | translate }} ({{ visningsgruppe().invitasjoner.length }})</h3>
        @for (invitasjon of invitasjoner(); track invitasjon.id) {
          <div class="invitasjon">
            <administrasjon-medlem [medlem]="invitasjon"/>
          </div>
        }
      </section>

      <section>
        <h3>{{ 'Deaktiverte' | translate }} ({{ inaktiveMedlemmer().length }})</h3>
        @for (medlem of inaktiveMedlemmer(); track medlem.id) {
          <administrasjon-medlem [medlem]="medlem"/>
        }
      </section>

      <section>
        <h3>{{ 'Endringshendelser' | translate }}</h3>
        <button mat-button type="button" (click)="gaaTilEndringshendelser()">{{ 'Vis endringshendelser' | translate }}</button>
      </section>
    </div>
  }
</section>
